import { Typography } from '@qlub-dev/qlub-kit';
import { FC } from 'react';

export interface IPlainTextMessageProps {
    text: string;
}

const PlainTextMessage: FC<IPlainTextMessageProps> = ({ text }) => {
    return <Typography typo="caption_overline">{text}</Typography>;
};

export default PlainTextMessage;
